document.addEventListener('DOMContentLoaded', function() {
    const selectors = {
        filter: '[data-filter-events]',
        eventCards: '[data-event-card]',
        noResults: '[data-no-results]'
    }

    const filter = document.querySelector(selectors.filter);
    const eventCards = document.querySelectorAll(selectors.eventCards);
    const noResults = document.querySelector(selectors.noResults);

    if(!filter || !eventCards) return;

    filter.addEventListener('change', function() {
        const category = this.value;
        let resultsCount = 0;

        eventCards.forEach(card => {
            const cardCategory = card.getAttribute('data-category');
            if(category === 'All' || cardCategory === category) {
                card.style.display = 'flex';
                resultsCount++;
            } else {
                card.style.display = 'none';
            }
        });

        if(resultsCount === 0) {
            noResults.style.display = 'flex';
        } else {
            noResults.style.display = 'none';
        }
    });
});